"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnitSystem = void 0;
/**
 * Unit system that should be used.
 */
var UnitSystem;
(function (UnitSystem) {
    /**
     * The metric system.
     */
    UnitSystem["metric"] = "metric";
    /**
     * The imperial system.
     */
    UnitSystem["imperial"] = "imperial";
})(UnitSystem = exports.UnitSystem || (exports.UnitSystem = {}));
//# sourceMappingURL=UnitSystem.js.map